export default {
    confirmLabel: '确定',
};



// WEBPACK FOOTER //
// ./components/input-item/locale/zh_CN.tsx